import { render, staticRenderFns } from "./AccountPasswordEdit.vue?vue&type=template&id=0ddade63&scoped=true"
import script from "./AccountPasswordEdit.vue?vue&type=script&lang=js"
export * from "./AccountPasswordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddade63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ddade63')) {
      api.createRecord('0ddade63', component.options)
    } else {
      api.reload('0ddade63', component.options)
    }
    module.hot.accept("./AccountPasswordEdit.vue?vue&type=template&id=0ddade63&scoped=true", function () {
      api.rerender('0ddade63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/accountPasswords/AccountPasswordEdit.vue"
export default component.exports